import Navigation from '../components/navbar/Navigation';
import { useState } from 'react';
import SocionicsContent from './SocionicsContent';
import Disclaimer from '../components/Disclaimer';
function Socionics() {
  const [personality1, setPersonality1] = useState('');
  const [personality2, setPersonality2] = useState('');
  return (
    <div className='font-link'>
      <Navigation loc='top'/>
      <SocionicsContent
        p1={personality1}
        p2={personality2}
        handleChange={(event) => setPersonality1(event.target.value)}
        handleChange1={(event) => setPersonality2(event.target.value)}
        />
      <Disclaimer />
      {/* <Navigation loc='bottom'/> */}
    </div>
  );
}

export default Socionics;